import { List, Create, Edit, View, NoteSheetPayment, FinalBillSheetPayment, PreSanctionPayment, MiscPayment, PreSanctionBank } from "../Components/index.js";

export default [
    {
        path: "/voucher/account/payment",
        component: List,
        name: "account.voucher.payment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/create",
        component: Create,
        name: "account.voucher.payment.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/misc",
        component: MiscPayment,
        name: "account.voucher.misc.payment.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/note-sheet-payment",
        component: NoteSheetPayment,
        name: "account.voucher.note.sheet.payment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/final-bill-note-sheet-payment",
        component: FinalBillSheetPayment,
        name: "account.voucher.final.bill.payment",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/pre-sanction-payment",
        component: PreSanctionPayment,
        name: "account.voucher.pre-sanction.payment",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/payment/pre-sanction-bank",
        component: PreSanctionBank,
        name: "account.voucher.pre-sanction.bank",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/voucher/account/payment/:id/edit",
        component: Edit,
        name: "account.voucher.payment.edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/voucher/account/payment/:id/view",
        component: View,
        name: "account.voucher.payment.view",
        meta: {
            requiresAuth: true,
        },
    },
];
